module.exports = __webpack_public_path__ + "media/dashboard/assets/images/check-circle-c78b8e300c7840606893180e1f809951.svg";